module.exports = __webpack_public_path__ + "img/header-img.bbb61ec4.png";